import React, { createContext, useContext } from "react";

/** Effective profile for /dashboard: AuthContext profile, or row refetched in TeacherOrDashboardLayout. */
const DashboardProfileContext = createContext(null);

export const DashboardProfileProvider = DashboardProfileContext.Provider;

export const useDashboardProfile = () => useContext(DashboardProfileContext);
